/**
 * @generated SignedSource<<b0277dd36f136cee72fc7117fa2b0f6b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type RejectedAccountsPageQuery$variables = {};
export type RejectedAccountsPageQuery$data = {
  readonly adminRejectedAccounts: ReadonlyArray<{
    readonly email: string;
    readonly id: string;
    readonly name: string;
    readonly rejectedAt: any | null;
    readonly restaurantName: string | null;
    readonly restaurantSlug: string | null;
  }>;
};
export type RejectedAccountsPageQuery = {
  response: RejectedAccountsPageQuery$data;
  variables: RejectedAccountsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PendingAccount",
    "kind": "LinkedField",
    "name": "adminRejectedAccounts",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "restaurantName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "restaurantSlug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rejectedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RejectedAccountsPageQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "RejectedAccountsPageQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "e5956965253be9d276008f686c051982",
    "id": null,
    "metadata": {},
    "name": "RejectedAccountsPageQuery",
    "operationKind": "query",
    "text": "query RejectedAccountsPageQuery {\n  adminRejectedAccounts {\n    id\n    name\n    email\n    restaurantName\n    restaurantSlug\n    rejectedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "1f9c76fded178fbc86fd00545d99b227";

export default node;
